import { from, iif, Observable, of, switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { authenticateResponseSchema } from '../../../schemas/authenticate-response.schema';
import { AuthenticatedUser } from '../../../schemas/authenticated-user.schema';
import { applySchema } from '../../../utils/apply-schema';
import { normalizeCallBehavior } from '../../../utils/normalize-call-behavior';
import { normalizeErrorReporting } from '../../../utils/normalize-error-reporting';
import { authwsEnvironment } from '../authws-environment';

/**
 * Authenticate this user has access to a specific product
 * @param authToken authenticationToken
 */
export function postAuthenticate(
  this: unknown,
  authToken: string
): Observable<AuthenticatedUser>;
/**
 * Authenticate this user has access to a specific product
 * @param username username/email
 * @param password password
 * @param product Trimble Maps Product
 * @param account account (needed if user is associated with multiple accounts)
 */
export function postAuthenticate(
  this: unknown,
  username: string,
  password: string,
  product: string,
  account?: string
): Observable<AuthenticatedUser>;
export function postAuthenticate(
  this: unknown,
  arg1: string,
  arg2?: string,
  arg3?: string,
  arg4?: string
) {
  const request: Record<string, unknown> = {};

  if (typeof arg2 === 'undefined') {
    request['authToken'] = arg1;
  } else {
    request['email'] = arg1;
    request['password'] = arg2;
    request['product'] = arg3;
    request['account'] = arg4;
  }

  return fromFetch(
    new Request(authwsEnvironment.resolve(this).securityAuthenticateUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      credentials: 'include',
      body: JSON.stringify(request),
    })
  ).pipe(
    switchMap((response: Response) => {
      return response.status === 400
        ? from(response.json() as Promise<Record<string, unknown>>)
        : of(response);
    }),
    switchMap((response) => {
      return iif(
        () => response instanceof Response,
        of(response) as unknown as Observable<Response>,
        of(
          new Response(JSON.stringify(response), {
            status:
              typeof (response as Record<string, unknown>)['accounts'] ===
              'undefined'
                ? 400
                : 200,
          })
        )
      );
    }),
    normalizeCallBehavior(),
    applySchema(authenticateResponseSchema),
    normalizeErrorReporting()
  );
}
